import Color from "color";

export const DEFAULT_THEME_COLOR = "#FF4600";

export function normalizeThemeColor(color) {
  const rawColor = String(color || "").trim();
  if (!rawColor) {
    return DEFAULT_THEME_COLOR;
  }

  try {
    return Color(rawColor).hex();
  } catch (error) {
    return DEFAULT_THEME_COLOR;
  }
}

export function generateLightColorShades(baseColor) {
  const color = Color(normalizeThemeColor(baseColor));
  return Array.from({ length: 10 }, (_, i) => color.mix(Color("white"), i * 0.1).hex());
}

export function generateDarkColorShades(baseColor) {
  const color = Color(normalizeThemeColor(baseColor));
  return Array.from({ length: 3 }, (_, i) => color.mix(Color("black"), (i + 1) * 0.1).hex());
}

export function getThemeCssVars(color) {
  const themeColor = normalizeThemeColor(color);
  const lightShades = generateLightColorShades(themeColor);
  const darkShades = generateDarkColorShades(themeColor);
  const cssVars = {
    "--el-color-primary": themeColor,
  };

  lightShades.forEach((shade, index) => {
    cssVars[`--el-color-primary-light-${index}`] = shade;
  });

  darkShades.forEach((shade, index) => {
    cssVars[`--el-color-primary-dark-${index}`] = shade;
  });

  return cssVars;
}

export function applyThemeCssVars(cssVars) {
  if (!process.client) {
    return;
  }

  Object.entries(cssVars || {}).forEach(([key, value]) => {
    document.documentElement.style.setProperty(key, value);
  });
}

export function getSavedThemeColor() {
  if (!process.client) {
    return "";
  }

  return String(window.localStorage.getItem("themeColor") || "").trim();
}

export function resolveThemeColor(...colors) {
  for (const color of colors) {
    const rawColor = String(color || "").trim();
    if (!rawColor) {
      continue;
    }

    try {
      return Color(rawColor).hex();
    } catch (error) {
      continue;
    }
  }

  return DEFAULT_THEME_COLOR;
}

export function changeTheme(color) {
  const themeColor = resolveThemeColor(color);
  const cssVars = getThemeCssVars(themeColor);

  applyThemeCssVars(cssVars);

  if (process.client) {
    if (color) {
      window.localStorage.setItem("themeColor", themeColor);
    } else {
      window.localStorage.removeItem("themeColor");
    }
  }

  return themeColor;
}
